
import { useEffect, useState } from "react";
import {ReactComponent as ImgHome} from "../assets/images/img-home.svg"
import { useTranslation } from "react-i18next"
import { queryReleaseNoticeRecordsList } from "../utility/service/notice-service";
import { checkDpSuccess } from "../utility/service/tool-service";
import { DataTable } from "primereact/datatable";
import PrimeTableFooter from "../components/PrimeTableFooter";
import NoInfo from "../components/NoInfo";
import { Column } from "primereact/column";
import PrimeDialog from "../components/dialog/PrimeDialog";
import SafeMarkdownRenderer from "../components/SafeMarkdownRenderer";

export default function Landing() {
    const { t } = useTranslation();
    const [rows,setRows] = useState([]);
    const [contentDialog,setContentDialog] = useState(false);
    const [contentObj,setContentObj] = useState({});

    const axios_queryReleaseNoticeRecordsList = (readMore=false)=>{
      queryReleaseNoticeRecordsList()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.noticeRecordsDtoList;
              if(data?.length > 0){
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      })
  }

  const startEndTimeBodyTemplate = (rowData, props)=>{
    if(rowData){
        return (
        <>
        {rowData?.releaseStartTime} ~ {rowData?.releaseEndTime}
        </>)
    }
  }

  const contentBodyTemplate = (rowData)=>{
    if(rowData){
      return (<div className="d-flex">
        {/* <Tooltip title={rowData?.content} placement='bottom'> */}
          <div
            onClick={() => {
              setContentObj(rowData);
              setContentDialog(true);
            }}
            className="text-ellipsis"
            style={{ cursor: 'pointer' }}>
              <div style={{ pointerEvents: 'none' }}>
                <SafeMarkdownRenderer content={rowData?.content} />
              </div>
          </div>
        {/* </Tooltip> */}
      </div>)
    }
  }

    useEffect(()=>{
      axios_queryReleaseNoticeRecordsList();
    },[])
  return (
    <>
       {
        rows?.length>0 ? (
          <div className="p-card">
          <div className="p-card-body">
              <DataTable
              stripedRows
              className="white-data-table hover-highlight no-shadow"
              tableStyle={{ minWidth: '55rem' }}
              value={rows}
              footer={rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false} />}
              emptyMessage={<NoInfo panel="table"/>}
              >
                  <Column style={{width:'25%'}} field="title" header={t('title')} />
                  <Column field="content"  header={t('content')} body={contentBodyTemplate} />
                  <Column field="releaseStartTime" body={startEndTimeBodyTemplate}  header={t('postingTime')} />
              </DataTable>
          </div>
  
      </div>
        ):(<div className="img-panel home">
          <p>
            {
              t("welcomeEsgPlatform")
            }
          </p>
        <ImgHome alt="" />
        </div>)
      }

<PrimeDialog
        scrollByBody={false}
        visible={contentDialog}
        size="lg"
        onClose={() => { setContentDialog(false) }}
        onConfirm={() => { setContentDialog(false) }}
        title={`${t('button.bulletin')} (${contentObj?.releaseStartTime} ~ ${contentObj?.releaseEndTime})`}
        bodyTemplate={<>
        <div className="col-12">
          <label
              className="form-label font-bold" style={{fontSize:'1.2rem'}}>
              {t("title")}
          </label>
          <span>{contentObj?.title}</span>
        </div>

        <div className="col-12">
          <label
              className="form-label font-bold" style={{fontSize:'1.2rem'}}>
              {t("content")}
          </label>
          <div style={{whiteSpace:"break-spaces"}}>
            <SafeMarkdownRenderer content={contentObj?.content} />
          </div>
        </div>
        
        </>}
      />
    </>
    
    
   
      
  )
}